
<portal to="modal" v-if="show">
    <div class="MyPosModal" ref="modalContainer" :class="{ isActive: show }">
        <div class="MyPosModal-Backdrop" @click="closeModal" ref="backdrop" />

        <div class="MyPosModal-Content" ref="content">
            <!-- Close Button -->
            <button class="MyPosModal-Close" @click="closeModal" type="button">
                <i class="ri-close-line"></i>
            </button>

            <div class="MyPosModal-Scrollable">
                <div class="mypos-modal-content special-offer">
                    <div class="offer-badge">
                        <i class="ri-time-line"></i>
                        <span>EXKLUSIVER PARTNER</span>
                    </div>

                    <div class="offer-content">
                        <div class="offer-info">
                            <div class="partner-logo">
                                <img src="/partners/mypos.png" alt="MyPos" />
                                <span class="partner-label">Unser Partner</span>
                            </div>
                            <div class="offer-description">
                                <p class="promo-description">
                                    Als TaxiFusion Partner erhalten Sie das myPOS Go 2 Terminal
                                    für nur 9€. Profitieren Sie von günstigen
                                    Transaktionsgebühren und nahtloser Integration mit
                                    TaxiFusion.
                                </p>
                                <div class="promo-benefits">
                                    <div class="benefit-item">
                                        <i class="ri-check-line"></i>
                                        <span>myPOS Go 2 Terminal für nur 9€</span>
                                    </div>
                                    <div class="benefit-item">
                                        <i class="ri-check-line"></i>
                                        <span>Bis zu 2 Geräte je Auto</span>
                                    </div>
                                </div>
                            </div>

                            <div class="process-steps">
                                <h4>So funktioniert's:</h4>
                                <div class="step">
                                    <div class="step-number">1</div>
                                    <div class="step-content">
                                        <strong>Registrierung bei MyPos</strong>
                                        <p>
                                            Klicken Sie auf "Jetzt bei MyPos registrieren" und
                                            achten Sie darauf, dass Sie über unseren
                                            Partner-Link registrieren.
                                        </p>
                                    </div>
                                </div>
                                <div class="step">
                                    <div class="step-number">2</div>
                                    <div class="step-content">
                                        <strong>Bei uns melden</strong>
                                        <p>
                                            Melden Sie sich nach der Registrierung bei uns,
                                            damit wir die Verbindung herstellen können.
                                        </p>
                                    </div>
                                </div>
                                <div class="step">
                                    <div class="step-number">3</div>
                                    <div class="step-content">
                                        <strong>Terminal erhalten</strong>
                                        <p>
                                            Sie erhalten bis zu 2 Geräte je Auto. Abholung oder
                                            Versand möglich (Versandkosten werden berechnet).
                                        </p>
                                    </div>
                                </div>
                                <div class="step">
                                    <div class="step-number">4</div>
                                    <div class="step-content">
                                        <strong>MyPos mit TaxiFusion verbinden</strong>
                                        <p>
                                            Gehen Sie in Ihre
                                            <router-link
                                                to="/settings"
                                                class="settings-link"
                                                @click.native="closeModal"
                                                >Einstellungen</router-link
                                            >
                                            und verbinden Sie MyPos mit TaxiFusion.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="product-image">
                            <img src="/partners/myPOS-GO2.webp" alt="MyPos Go2 Terminal" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="MyPosModal-Actions">
                <Button variant="basic" @onClick="closeModal">Schließen</Button>
                <Button @onClick="handleMyPosRedirect" :isLoading="isLoading">
                    Jetzt bei MyPos registrieren
                    <template #iconAfter>
                        <i class="ri-external-link-line"></i>
                    </template>
                </Button>
            </div>
        </div>
    </div>
</portal>
